import { useI18n } from '../I18n/I18n.hooks';

const keys = { name: 'name', members: 'members' };

export const useQuotationGroupI18n = () => {
  return useI18n({ keys, keyPrefix: 'core.quotationGroup.hooks' });
};
